<template>
  <div ref="root" v-loading="loading">

    <el-card>
      <el-descriptions
        title="订单详情"
        direction="vertical"
        :column="2"
        border
        :labelStyle="{border: '1px solid #000000'}"
        :contentStyle="{border: '1px solid #000000'}"
      >
        <!-- 基本信息 -->
        <el-descriptions-item label="基本信息">
          <!-- 店铺 -->
          <!-- <div class="big">
            <div>店铺:</div>
            <div>{{Data.site}}</div>
          </div> -->
          <!-- 订单id -->
          <div class="big">
            <div>订单id:</div>
            <div>{{Data.ID_}}</div>
          </div>
          <!-- 平台状态 -->
          <div class="big">
            <div>平台状态:</div>
            <div>{{Data.status}}</div>
          </div>
          <!-- 下单时间 -->
          <div class="big">
            <div>下单时间:</div>
            <div>{{Data.date_created_gmt}}</div>
          </div>
          <!-- 物流方式 -->
          <div class="big">
            <div>物流方式:</div>
            <div>{{Data.shiptype}}</div>
          </div>
          <!-- 客户备注 -->
          <div class="big">
            <div>客户备注:</div>
            <div>{{Data.customer_note}}</div>
          </div>
          <!-- 国际物流单号 -->
          <div class="big">
            <div>国际物流单号:</div>
            <div>{{Data.int_no}}</div>
          </div>
          
        </el-descriptions-item>
        
        <!-- 配送信息 -->
        <el-descriptions-item label="配送信息">
          <!-- 收件人 -->
          <div class="big">
            <div>收件人:</div>
            <div>{{Data.name}}</div>
          </div>
          <!-- 邮箱 -->
          <div class="big">
            <div>邮箱:</div>
            <div>{{Data.email}}</div>
          </div>
          <!-- 省/州 -->
          <div class="big">
            <div>省/州:</div>
            <div>{{Data.state}}</div>
          </div>
          <!-- 邮编 -->
          <div class="big">
            <div>邮编:</div>
            <div>{{Data.postcode}}</div>
          </div>
          <!-- 地址 -->
          <div class="big">
            <div>地址:</div>
            <div>{{Data.address}}</div>
          </div>
          <!-- 电话 -->
          <div class="big">
            <div>电话:</div>
            <div>{{Data.phone}}</div>
          </div>
          <!-- 国家 -->
          <div class="big">
            <div>国家:</div>
            <div>{{Data.country}}</div>
          </div>
          <!-- 城市 -->
          <div class="big">
            <div>城市:</div>
            <div>{{Data.city}}</div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="box">
      <p style="display:inline-block; margin-right: 20px;">订购商品</p>
      <!-- <el-button size="small" type="primary" style="display:inline-block" @click="confirm">发货</el-button> -->
        
        <el-table
          :row-style="{height:'100px'}"
          :cell-style="{padding:1,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000'}"
          :data="arr"
          @selection-change="selectionChange"
          border
          style="width: 100%;border: 1px solid #000000">

          <!-- 全选按钮 -->
          <!-- <el-table-column
            align="center"
            type="selection"
            label="全选"
            width="40px">
          </el-table-column> -->

          <!-- SKU -->
          <el-table-column prop="sku" label="SKU" width="180">
          </el-table-column>

          <!-- 图片 -->
          <el-table-column label="图片" width="70px">
            <template slot-scope="scope">
              <el-popover placement="right" width="500" trigger="click">
                <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
                <img :src="scope.row.img" alt="暂无图片" width="50px" height="50px" slot="reference">
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column label="图片" width="120px">
            <template slot-scope="scope">
              <img :src="scope.row.img" alt="暂无图片" width="100px">
            </template>
          </el-table-column> -->

          <!-- 名称 -->
          <el-table-column prop="product_name" label="名称" width="230">
          </el-table-column>

          <!-- 定制信息 -->
          <el-table-column label="定制信息">
            <template slot-scope="scope">
              <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
              <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
              <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
              <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
            </template>
          </el-table-column>

          <!-- 袖标 -->
          <el-table-column label="袖标" width="125">
            <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
              <span v-for="(item,index) in scope.row.armband" :key="index">
                  <el-popover placement="left" trigger="click" width="300">
                    <img :src="item" width="100%" style="background:gray" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="123"
                      width="48px" height="48px"
                      style="margin:1px;background:gray"
                    />
                  </el-popover>
                </span>
            </template>
          </el-table-column>

          <!-- 配件 -->
          <el-table-column label="配件" width="125">
            <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
              <span v-for="(item,index) in scope.row.accessories" :key="index">
                  <el-popover placement="left" trigger="click" width="300">
                    <img :src="item" width="100%" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="123"
                      width="50px" height="50px"
                    />
                  </el-popover>
                </span>
            </template>
          </el-table-column>

          <!-- 数量 -->
          <el-table-column prop="quantity" label="数量" width="40px">
          </el-table-column>

          <!-- 商品备注 -->
          <el-table-column label="商品备注" width="100px">
              <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
          </el-table-column>

          <!-- 商品状态 -->
          <el-table-column prop="product_status" label="状态" width="130px">
            <template slot-scope="scope">
              <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                <el-button
                  :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '仓库已发货' ? 'success' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : ''))))))))))" 
                  size="mini">
                    {{scope.row.product_status}}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <!-- 定制信息 -->
          <!-- <el-table-column label="定制信息" width="200px">
            <template slot-scope="scope">
              <div>尺码:{{scope.row.size}}</div>
              <div>配件:{{scope.row.accessories}}</div>
              <div>袖标:{{scope.row.armband}}</div>
              <div>字号:{{scope.row.word_no == "null" ? "无" : scope.row.word_no}}</div>
            </template>
          </el-table-column> -->

          <!-- 单价 -->
          <!-- <el-table-column prop="price" label="单价" width="100px">
          </el-table-column> -->

          <!-- 国际物流单号 -->
          <el-table-column prop="int_no" label="国际物流单号" width="150">
          </el-table-column>

        </el-table>

        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <span>您确认要发货吗?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="send_">确 定</el-button>
          </span>
        </el-dialog>

    </el-card>

    <el-card>
      <el-table
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
        :data="jl"
        border
        style="border: 1px solid #000000;width: 100%">

        <el-table-column
            prop="product_id"
            label="商品id"
            align="center">
        </el-table-column>


        <el-table-column
            prop="product_status"
            label="商品状态"
            align="center">
        </el-table-column>


        <el-table-column
            prop="time"
            label="时间"
            align="center">
        </el-table-column>


        <el-table-column
            prop="person"
            label="操作者"
            align="center">
        </el-table-column>

      </el-table>
    </el-card>

  </div>
</template>

<script>
import { getOD_,Send,getProduct_,hqjl } from '../../api/api'
export default {
  data() {
    return {

      jl:[],

      dialogVisible: false,
      Data: [],//订单详情
      loading: true,
      tableData: [],//订购商品
      senddata:[],//发货商品
      arr:[]
    };
  },
  created() {
    var site_ = this.$route.query.site;
    var ID_ = this.$route.query.ID_;
    //获取单个订单
    getOD_(site_,ID_).then(res => {
      for(var i of res){
        if(i.site == site_ && i.ID_ == ID_){
          this.Data = i;
          // this.tableData = JSON.parse(i.line_items);
        }
      }
      // console.log(this.Data);
      // this.loading = false;
    })
    //获取单个订单中的所有商品
    var params = {
      site:site_,
      ID:ID_
    }
    getProduct_(params).then(res => {
      for (const i of res) {
        if(i.armband == null || i.armband == undefined || i.armband == ''){
          i.armband = '无';
        }
        else if(i.armband.charAt(0) == "h"){
          i.armband = i.armband.split(",");
        }

        if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
          i.accessories = '无';
        }
        else if(i.accessories.charAt(0) == "h"){
          i.accessories = i.accessories.split(",");
        }
      }
      this.arr = res;

      var www = [];
      for(var i of res){
        www.push(i.product_id);
      }
      // console.log(www);
      hqjl(www).then(res => {
        this.jl = res;
      })

      this.loading = false;
    })
  },
  methods: {
    //复选框
    selectionChange(selection) {
      this.senddata = selection;
      console.log(selection[0].int_no);
    },
    // X
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    //点击发货(二次确认)
    confirm(){
      this.dialogVisible = true;
    },
    //点击确认(确认发货)
    send_(){
      this.dialogVisible = false;
      console.log(this.senddata);
      //未选择发货的商品
      if(this.senddata.length == 0){
        this.$message({
          message:"请先选择要发货的商品！！！",
          type:"error"
        })
        return false;
      }else if(this.senddata.length != 0){
        if(this.Data.shiptype == '包邮' || this.Data.shiptype == 'EMS' || this.Data.shiptype == '佐川'){
          for(var u of this.senddata){
            if(u.int_no != "" && u.int_no != null && u.int_no != undefined){
              this.$message({
                message:'您选中的商品中存在已经发过货的商品，不能二次发货！！！',
                type:'error'
              })
              return false;
            }
          }
          var a = 0;
          for(var i of this.senddata){
            a += i.quantity;
          }
          var count = a.toString();
          var total = (3 * a).toString();
          if(this.Data.country == "BE" || this.Data.country == "BG" || this.Data.country == "CZ" || this.Data.country == "DK" || this.Data.country == "DE" || this.Data.country == "EE" || this.Data.country == "IE" || this.Data.country == "EL" || this.Data.country == "ES" || this.Data.country == "FR" || this.Data.country == "HR" || this.Data.country == "IT" || this.Data.country == "CY" || this.Data.country == "LV" || this.Data.country == "LT" || this.Data.country == "LU" || this.Data.country == "HU" || this.Data.country == "MT" || this.Data.country == "NL" || this.Data.country == "AT" || this.Data.country == "PL" || this.Data.country == "PT" || this.Data.country == "RO" || this.Data.country == "SI" || this.Data.country == "SK" || this.Data.country == "FI" || this.Data.country == "SE"){
            var now = new Date();
            var original_number = now.getTime().toString();
            var sss = [];
            for(var t = 0;t < this.senddata.length;t++){
              sss.push(this.senddata[t].product_id);
            }
            console.log(sss);
            if(this.Data.int_no == '' || this.Data.int_no == null || this.Data.int_no == undefined){
              this.Data.int_no = '';
            }
            // "customer_id": "52061","customer_userid": "48321", 线上
            // "customer_id": "52401","customer_userid": "48661", 测试
            var params = {
                "site": this.senddata[0].site,
                "ID_": this.senddata[0].ID_,
                "int_no": this.Data.int_no,
                "product_ID": sss,
                "consignee_name": this.Data.name,
                "consignee_address": this.Data.address,
                "consignee_telephone": this.Data.phone,
                "country": this.Data.country,
                "consignee_state": this.Data.state,
                "consignee_city": this.Data.city,
                "consignee_postcode": this.Data.postcode,
                "customer_id": "52061",
                "customer_userid": "48321",
                "order_customerinvoicecode": this.senddata[0].ID_ + "-" + original_number,
                "product_id": "9321",
                "weight": "100",
                "orderInvoiceParam": [
                    {
                      "invoice_amount": total,
                      "invoice_pcs": count,
                      "invoice_title": "T-shirt",
                      "hs_code": "6109100010"
                    }
                ]
            };
            Send(params).then(res => {}).catch(error => {
              console.log(error);
            });
            // for(var j = 0; j < this.arr.length; j++){
            //   for(var i = 0; i < this.senddata.length; i++){
            //     if(this.senddata[i].site == this.arr[j].site && this.senddata[i].ID_ == this.arr[j].ID_){
            //       this.senddata[i].product_status = "物流已发货";
            //     }
            //   }
            // }
          }else if(this.Data.country != "BE" && this.Data.country != "BG" && this.Data.country != "CZ" && this.Data.country != "DK" && this.Data.country != "DE" && this.Data.country != "EE" && this.Data.country != "IE" && this.Data.country != "EL" && this.Data.country != "ES" && this.Data.country != "FR" && this.Data.country != "HR" && this.Data.country != "IT" && this.Data.country != "CY" && this.Data.country != "LV" && this.Data.country != "LT" && this.Data.country != "LU" && this.Data.country != "HU" && this.Data.country != "MT" && this.Data.country != "NL" && this.Data.country != "AT" && this.Data.country != "PL" && this.Data.country != "PT" && this.Data.country != "RO" && this.Data.country != "SI" && this.Data.country != "SK" && this.Data.country != "FI" && this.Data.country != "SE"){
            var now = new Date();
            var original_number = now.getTime().toString();
            var sss = [];
            for(var t = 0;t < this.senddata.length;t++){
              sss.push(this.senddata[t].product_id);
            }
            console.log(sss);
            if(this.Data.int_no == '' || this.Data.int_no == null || this.Data.int_no == undefined){
              this.Data.int_no = '';
            }
            var params = {
                "site": this.senddata[0].site,
                "ID_": this.senddata[0].ID_,
                "int_no": this.Data.int_no,
                "product_ID": sss,
                "consignee_name": this.Data.name,
                "consignee_address": this.Data.address,
                "consignee_telephone": this.Data.phone,
                "country": this.Data.country,
                "consignee_state": this.Data.state,
                "consignee_city": this.Data.city,
                "consignee_postcode": this.Data.postcode,
                "customer_id": "52061",
                "customer_userid": "48321",
                "order_customerinvoicecode": this.senddata[0].ID_ + "-" + original_number,
                "product_id": "11141",
                "weight": "100",
                "orderInvoiceParam": [
                    {
                      "invoice_amount": total,
                      "invoice_pcs": count,
                      "invoice_title": "T-shirt",
                      "hs_code": "6109100010"
                    }
                ]
            };
            Send(params).then(res => {}).catch(error => {
              console.log(error);
            });
            // for(var j = 0; j < this.arr.length; j++){
            //   for(var i = 0; i < this.senddata.length; i++){
            //     if(this.senddata[i].site == this.arr[j].site && this.senddata[i].ID_ == this.arr[j].ID_){
            //       this.senddata[i].product_status = "物流已发货";
            //     }
            //   }
            // }
          }
        }else if(this.Data.shiptype != '包邮' && this.Data.shiptype != 'EMS' && this.Data.shiptype != '佐川'){
          this.$message({
            message:'物流方式不是(包邮,EMS,佐川),不能进行发货。',
            type:'error'
          })
        }  
      }
    }
  },
  updated(){
      // var arr = this.$refs.val;
      // for(var i of arr){
      //   if(i.innerHTML == "袖标:Serie A" || i.innerHTML == "袖标:セリエA"){
      //       i.innerHTML = "袖标:意甲标";
      //   }else if(i.innerHTML == "袖标:Premier League + No room for racism" || i.innerHTML == "袖标:プレミアリーグ" || i.innerHTML == "袖标:Premier League"){
      //       i.innerHTML = "袖标:英超标";
      //   }else if(i.innerHTML == "袖标:Premier League d'or + No room for racism" || i.innerHTML == "袖标:Champions + No room for racism" || i.innerHTML == "袖标:ゴールドプレミアリーグ" || i.innerHTML == "袖标:Gold Premier League"){
      //       i.innerHTML = "袖标:英超金标(曼城)";
      //   }else if(i.innerHTML == "袖标:La Liga" || i.innerHTML == "袖标:ラリーガ"){
      //       i.innerHTML = "袖标:西甲标";
      //   }else if(i.innerHTML == "袖标:Bundesliga" || i.innerHTML == "袖标:ブンデスリーガ"){
      //       i.innerHTML = "袖标:德甲标";
      //   }else if(i.innerHTML == "袖标:Ligue 1" || i.innerHTML == "袖标:リーグアン"){
      //       i.innerHTML = "袖标:法甲标";
      //   }else if(i.innerHTML == "袖标:Coupe Libertadores 2" || i.innerHTML == "袖标:Copa Libertadores 2" || i.innerHTML == "袖标:リベルタドーレスカップ" || i.innerHTML == "袖标:CONMEBOL 2"){
      //       i.innerHTML = "袖标:2次南美解放杯冠军";
      //   }else if(i.innerHTML == "袖标:Coupe Libertadores" || i.innerHTML == "袖标:Copa Libertadores" || i.innerHTML == "袖标:リベレーターカップ" || i.innerHTML == "袖标:Copa Libertadores Cup"){
      //       i.innerHTML = "袖标:南美解放者杯";
      //   }else if(i.innerHTML == "袖标:Recopa Sudamericana" || i.innerHTML == "袖标:南米カップウィナーズカップ"){
      //       i.innerHTML = "袖标:南美优胜者杯";
      //   }else if(i.innerHTML == "袖标:Liga Portugal" || i.innerHTML == "袖标:リーガポルトガル"){
      //       i.innerHTML = "袖标:葡萄牙联赛标";
      //   }else if(i.innerHTML == "袖标:Coupe du monde 2022" || i.innerHTML == "袖标:Copa Mundial" || i.innerHTML == "袖标:ワールド カップ" || i.innerHTML == "袖标:FIFA World Cup 2022"){
      //       i.innerHTML = "袖标:世界杯标";
      //   }else if(i.innerHTML == "袖标:Écusson des qualifications 2022" || i.innerHTML == "袖标:FIFA Living Football" || i.innerHTML == "袖标:ワールドカップ予選" || i.innerHTML == "袖标:FIFA World Cup Qualification 2022"){
      //       i.innerHTML = "袖标:世界杯预赛标"
      //   }else if(i.innerHTML == "袖标:UEFA Champions League" || i.innerHTML == "袖标:Champions Leauge" || i.innerHTML == "袖标:チャンピオンズリーグ"){
      //       i.innerHTML = "袖标:欧冠";
      //   }else if(i.innerHTML == "袖标:UCL 5" || i.innerHTML == "袖标:Champions Leauge 5" || i.innerHTML == "袖标:チャンピオンズリーグ 5" || i.innerHTML == "袖标:UEFA Champions League 5"){
      //       i.innerHTML = "袖标:欧冠5";
      //   }else if(i.innerHTML == "袖标:UCL 6" || i.innerHTML == "袖标:Champions Leauge 6" || i.innerHTML == "袖标:チャンピオンズリーグ 6" || i.innerHTML == "袖标:UEFA Champions League 6"){
      //       i.innerHTML = "袖标:欧冠6";
      //   }else if(i.innerHTML == "袖标:UCL 7" || i.innerHTML == "袖标:Champions Leauge 7" || i.innerHTML == "袖标:チャンピオンズリーグ 7" || i.innerHTML == "袖标:UEFA Champions League 7"){
      //       i.innerHTML = "袖标:欧冠7";
      //   }else if(i.innerHTML == "袖标:UCL 13" || i.innerHTML == "袖标:Champions Leauge 13" || i.innerHTML == "袖标:チャンピオンズリーグ 13" || i.innerHTML == "袖标:UEFA Champions League 13"){
      //       i.innerHTML = "袖标:欧冠13";
      //   }else if(i.innerHTML == "袖标:UCL 14" || i.innerHTML == "袖标:チャンピオンズリーグ 14" || i.innerHTML == "袖标:UEFA Champions League 14"){
      //       i.innerHTML = "袖标:欧冠14";
      //   }else if(i.innerHTML == "袖标:Fondation" || i.innerHTML == "袖标:Fundación" || i.innerHTML == "袖标:財団" || i.innerHTML == "袖标:UEFA Foundation"){
      //       i.innerHTML = "袖标:基金会";
      //   }else if(i.innerHTML == "袖标:Champions de la Serie A" || i.innerHTML == "袖标:Campeones de la Serie A" || i.innerHTML == "袖标:セリエAチャンピオン" || i.innerHTML == "袖标:Champions Serie  A"){
      //       i.innerHTML = "袖标:意甲冠军";
      //   }else if(i.innerHTML == "袖标:Coupe d'Italie" || i.innerHTML == "袖标:Cockade de Italia" || i.innerHTML == "袖标:イタリアカップ" || i.innerHTML == "袖标:Cockade of Italy"){
      //       i.innerHTML = "袖标:意大利杯标";
      //   }else if(i.innerHTML == "袖标:FINALE PARIS 2022" || i.innerHTML == "袖标:FINAL PARIS 2022" || i.innerHTML == "袖标:ファイナルパリ2022"){
      //       i.innerHTML = "袖标:巴黎决赛2022";
      //   }else if(i.innerHTML == "袖标:Champions League Winner" || i.innerHTML == "袖标:チャンピオンズリーグ優勝者" || i.innerHTML == "袖标:UCL Title"){
      //       i.innerHTML = "袖标:欧冠卫冕标";
      //   }else if(i.innerHTML == "袖标:Women's Super League" || i.innerHTML == "袖标:FA女子スーパーリーグ" || i.innerHTML == "袖标:Barclays Women's Super League"){
      //       i.innerHTML = "袖标:巴克莱女子超级联赛标";
      //   }else if(i.innerHTML == "袖标:Nexen Tire"){
      //       i.innerHTML = "袖标:耐克森轮胎";
      //   }else if(i.innerHTML == "袖标:Coupe du monde des clubs de la FIFA" || i.innerHTML == "袖标:Copa Mundial de Clubes de la FIFA" || i.innerHTML == "袖标:FIFAクラブワールドカップ" || i.innerHTML == "袖标:FIFA Club World Cup"){
      //       i.innerHTML = "袖标:世俱杯标";
      //   }else if(i.innerHTML == "袖标:Copa 2022 " || i.innerHTML == "袖标:ディフェン ディング チャンピオン2022"){
      //       i.innerHTML = "袖标:卫冕2022";
      //   }else if(i.innerHTML == "袖标:14th UEFA Champions League Winner" || i.innerHTML == "袖标:第14回UEFAチャンピオンズリーグ優勝"){
      //       i.innerHTML = "袖标:卫冕14";
      //   }else if(i.innerHTML == "袖标:UEFA Women's Champions League" || i.innerHTML == "袖标:Copa de la UEFA Femenina" || i.innerHTML == "袖标:UEFA女子チャンピオンズリーグ" || i.innerHTML == "袖标:UWCL"){
      //       i.innerHTML = "袖标:UEFA女子冠军标 1";
      //   }else if(i.innerHTML == "袖标:We play strong"){
      //       i.innerHTML = "袖标:UEFA女子冠军标 2";
      //   }else if(i.innerHTML == "袖标:Champions de la Bundesliga 2022/23" || i.innerHTML == "袖标:Campeones de la Bundesliga 2022/23" || i.innerHTML == "袖标:ブンデスリーガチャンピオン2022/23" || i.innerHTML == "袖标:Bundesliga Champion 2022/23"){
      //       i.innerHTML = "德甲冠军2022/23";
      //   }else if(i.innerHTML == "袖标:Champions de la Bundesliga 2021/22" || i.innerHTML == "袖标:Campeones de la Bundesliga 2021/22" || i.innerHTML == "袖标:ブンデスリーガチャンピオン2021/22" || i.innerHTML == "袖标:Bundesliga Champions 21/22"){
      //       i.innerHTML = "袖标:德甲冠军2021/22";
      //   }else if(i.innerHTML == "袖标:10th Champion" || i.innerHTML == "袖标:10 Campeones" || i.innerHTML == "袖标:10回チャンピオン" || i.innerHTML == "袖标:Serienmeister"){
      //       i.innerHTML = "袖标:拜仁10次冠军标";
      //   }else if(i.innerHTML == "袖标:10th Champion 2022" || i.innerHTML == "袖标:Champion 2022" || i.innerHTML == "袖标:第10回チャンピオン2022" || i.innerHTML == "袖标:10th Champion 2022"){
      //       i.innerHTML = "袖标:巴黎10连冠标";
      //   }else if(i.innerHTML == "袖标:Champions de la Liga Portugal" || i.innerHTML == "袖标:Campeones de la Liga Portugal" || i.innerHTML == "袖标:ポルトガルリーグチャンピオン" || i.innerHTML == "袖标:Champions Liga Portugal"){
      //       i.innerHTML = "袖标:葡萄牙甲级联赛冠军";
      //   }else if(i.innerHTML == "袖标:Insigne d'Honneur 7 Coupes" || i.innerHTML == "袖标:7 Champions Leauge" || i.innerHTML == "袖标:7チャンピオンズリーグ" || i.innerHTML == "袖标:BOH7"){
      //       i.innerHTML = "袖标:7次杯标";
      //   }else if(i.innerHTML == "袖标:digitalbits"){
      //       i.innerHTML = "袖标:digitalbits赞助补丁";
      //   }else if(i.innerHTML == "袖标:Bitget"){
      //       i.innerHTML = "袖标:Bitget赞助补丁";
      //   }else if(i.innerHTML == "袖标:BitMEX"){
      //       i.innerHTML = "袖标:BitMEX赞助补丁";
      //   }else if(i.innerHTML == "袖标:Scope Markets"){
      //       i.innerHTML = "袖标:Scope Markets 赞助补丁";
      //   }else if(i.innerHTML == "袖标:WhaleFin"){
      //       i.innerHTML = "袖标:WhaleFin 赞助商标";
      //   }else if(i.innerHTML == "袖标:Expedia"){
      //       i.innerHTML = "袖标:Expedia 赞助商标";
      //   }else if(i.innerHTML == "袖标:KOHLER"){
      //       i.innerHTML = "袖标:KOHLER赞助补丁";
      //   }else if(i.innerHTML == "袖标:DXC Technology" || i.innerHTML == "袖标:DXC"){
      //       i.innerHTML = "袖标:DXC Technology赞助商标";
      //   }else if(i.innerHTML == "袖标:BEKO" || i.innerHTML == "袖标:Beko"){
      //       i.innerHTML = "袖标:Beko 赞助补丁";
      //   }else if(i.innerHTML == "袖标:HARFID"){
      //       i.innerHTML = "袖标:HARFID";
      //   }else if(i.innerHTML == "袖标:Opel"){
      //       i.innerHTML = "袖标:Opel赞助补丁";
      //   }else if(i.innerHTML == "袖标:Qatar Airways"){
      //       i.innerHTML = "袖标:卡塔尔航空赞助商标";
      //   }else if(i.innerHTML == "袖标:ooredoo"){
      //       i.innerHTML = "袖标:ooredoo";
      //   }else if(i.innerHTML == "袖标:QNB"){
      //       i.innerHTML = "袖标:QNB";
      //   }else if(i.innerHTML == "袖标:GOAT"){
      //       i.innerHTML = "袖标:GOAT";
      //   }else if(i.innerHTML == "袖标:Kalise"){
      //       i.innerHTML = "袖标:Kalise赞助商标";
      //   }else if(i.innerHTML == "Cygames"){
      //       i.innerHTML = "袖标:Cygames赞助商标";
      //   }else if(i.innerHTML == "袖标:Cinch"){
      //       i.innerHTML = "袖标:Cinch赞助商标";
      //   }else if(i.innerHTML == "袖标:Ammerlander"){
      //       i.innerHTML = "袖标:阿莫兰赞助商标";
      //   }else if(i.innerHTML == "袖标:HYUNDAI" || i.innerHTML == "袖标:Hyundai"){
      //       i.innerHTML = "袖标:现代汽车赞助商标";
      //   }else if(i.innerHTML == "袖标:VISIT RWANDA" || i.innerHTML == "袖标:Visit Rwanda"){
      //       i.innerHTML = "袖标:VISIT RWANDA";
      //   }else if(i.innerHTML == "袖标:Würth" || i.innerHTML == "袖标:Wurth"){
      //       i.innerHTML = "袖标:伍尔特赞助商标";
      //   }else if(i.innerHTML == '配件:Shorts' || i.innerHTML == '配件:Pantalones Cortos' || i.innerHTML == '配件:Des pantalons courts' || i.innerHTML == '配件:短パン'){
      //     i.innerHTML = '配件:球裤';
      //   }else if(i.innerHTML == '配件:Socks' || i.innerHTML == '配件:Medias' || i.innerHTML == '配件:Chaussettes de foot' || i.innerHTML == '配件:ソックス' || i.innerHTML == '配件:Chaussettes'){
      //     i.innerHTML = '配件:袜子';
      //   }
      // }
  }
};
</script>

<style lang="scss" scoped>
p{
  font-weight: bolder;
  margin-bottom: 10px;
}
.big{
  div:nth-child(1){
    width: 100px;
  }
  div{
    display: inline-block;
  }
}
.box{
  .el-table{
    display: inline-block;
    vertical-align: top;
  }
}
</style>
<el-table
          :row-style="{height:'100px'}"
          :cell-style="{padding:0}"
          :data="tableData"
          @selection-change="selectionChange"
          border
          style="width: 100%">
          <!-- 全选按钮 -->
          <el-table-column
            align="center"
            type="selection"
            label="全选"
            width="40px">
          </el-table-column>
          <!-- SKU -->
          <el-table-column prop="sku" label="SKU" width="180">
          </el-table-column>
          <!-- 图片 -->
          <el-table-column label="图片" width="120px">
            <template slot-scope="scope">
              <img :src="scope.row.image.src" alt="暂无图片" width="100px" >
            </template>
          </el-table-column>
          <!-- 名称 -->
          <el-table-column prop="name" label="名称" width="1000px">
          </el-table-column>
          <!-- 型号 -->
          <el-table-column  label="型号" width="100" align="left">
            <span slot-scope="scope">
              <div v-for="item in scope.row.meta_data" :key="item.id">{{ item.display_key == "Talla" || item.display_key == "Size" || item.display_key == "Taille" || item.display_key == "サイズ" ? "尺码:" + item.display_value : "" }}</div>
            </span>
          </el-table-column>
          <!-- 定制信息 -->
          <el-table-column  label="定制信息" width="200" align="left">
            <span slot-scope="scope">
              <div ref="val" v-for="item in scope.row.meta_data" :key="item.id">{{ item.display_key.substring(0,15) == "Nombre y Número" || item.display_key.substring(0,15) == "Name and Number" || item.display_key.substring(0,19) == "選手ネーム／ナンバーを選択してください" || item.display_key.substring(0,13) == "Nom et numéro" ? "字号:" + item.display_value : (item.display_key.substring(0,6) == "Parche" || item.display_key.substring(0,7) == "écusson" || item.display_key.substring(0,2) == "腕章" || item.display_key.substring(0,5) == "Patch" ? "袖标:" + item.display_value : (item.display_key.substring(0,10) == "Accesorios" || item.display_key.substring(0,11) == "Accessories" || item.display_key.substring(0,11) == "Accessoires" || item.display_key.substring(0,6) == "アクセサリー" ? "配件:" + item.display_value : "" ) ) }}</div>
            </span>
          </el-table-column>
          <!-- 单价 -->
          <el-table-column prop="price" label="单价">
          </el-table-column>
          <!-- 数量 -->
          <el-table-column prop="quantity" label="数量">
          </el-table-column>
        </el-table>
        <hr>
        <hr>
        <hr>
        <hr>

        <!-- 交易信息 -->
        <el-descriptions-item label="交易信息">
          <!-- 订单金额 -->
          <div class="big">
            <div>订单金额:</div>
            <div>{{Data.total}}</div>
          </div>
          <!-- 运费金额 -->
          <div class="big">
            <div>运费金额:</div>
            <div>{{Data.shipping_total}}</div>
          </div>
          <!-- 币种 -->
          <div class="big">
            <div>币种:</div>
            <div>{{Data.currency}}</div>
          </div>
          <!-- 交易号 -->
          <div class="big">
            <div>交易号:</div>
            <div>{{Data.transaction_id}}</div>
          </div>
          <!-- 优惠金额 -->
          <div class="big">
            <div>优惠金额:</div>
            <div>{{Data.discount_total}}</div>
          </div>
          <!-- 付款方式 -->
          <div class="big">
            <div>付款方式:</div>
            <div>{{Data.payment_method}}</div>
          </div>
        </el-descriptions-item>